import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/default.jpg'


const _hoisted_1 = { class: "py-3" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    width: "100%",
    "wrap-class-name": "full-modal",
    title: _ctx.name,
    cancelText: "Close",
    onOk: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", { innerHTML: _ctx.allergyInfo }, null, 8, _hoisted_2)
      ]),
      (_ctx.image)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.image,
            alt: _ctx.name,
            class: "w-full"
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _imports_0,
            alt: _ctx.name,
            class: "w-full"
          }, null, 8, _hoisted_4))
    ]),
    _: 1
  }, 8, ["title", "onOk"]))
}